<template>
  <div>
    <div class="top-bar">
      <span>
        <i class="left" @click="back()"></i>
      </span>
      <span class="heading_new">Driver Salary</span>
      <span class="spacer" />
    </div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="main-container">
      <div class="noData" v-if="(!driverDetailsList.length && !salaryDetailsList.length)">
        <span>
          You have not added any Driver Details yet.
          <br />Click on Add Driver to add get started.
        </span>
        <form-add-button
          main_text="+ Add New"
          sub_text="Driver Details"
          class="custom-add-button margin-t-l"
          @click="initCreateForm()"
        ></form-add-button>
      </div>
      <div v-if="(driverDetailsList.length || salaryDetailsList.length)">
        <div class="row">
          <div class="col-6">
            <div class="d-heading">Driver details</div>
          </div>
          <div class="col-6">
            <div class="row-container justify-content-flex-end">
              <img src="@/assets/group-5.svg" class="Group-5" />
              <button class="text-green" @click="initCreateForm">Add New Driver</button>
            </div>
          </div>
        </div>
        <div class="margin-t-l">
          <data-table
            :columns="driverColumns"
            :tableData="driverDetailsList"
            :showinrow="true"
            :showhistory="false"
            :showedit="false"
            @delete="deleteDriver($event)"
          >
            <template v-slot:rowcontent="slotprops">
              <div>
                <p v-if="slotprops.value.column.key == 'srNo'">{{slotprops.value.index+1}}</p>
                <p
                  v-if="slotprops.value.column.key == 'driver_name'"
                >{{slotprops.value.record[slotprops.value.column.key]}}</p>
                <p
                  v-if="slotprops.value.column.key == 'licence_number'"
                >{{slotprops.value.record[slotprops.value.column.key]}}</p>
                <p
                  v-if="slotprops.value.column.key == 'proofs'"
                >{{slotprops.value.record[slotprops.value.column.key].length}}</p>
              </div>
            </template>
          </data-table>
        </div>
        <tl-header type="h1" class="margin-t-l">
          <div class="d_heading">Driver Salary Details</div>
        </tl-header>
        <div class="row">
          <div class="col-3" v-if="driverDetailsList.length > 1">
            <tl-select
              label="Driver"
              labelText="driver_name"
              :options="driverDetailsList"
              v-model="driverSalary.driver"
              @change="(val) => driverSalary.driver=val"
            ></tl-select>
          </div>
          <div class="col-3">
            <div class="label">
              <span class="input-label">Salary Date</span>
              <date-picker
                name="salary_date"
                :value="driverSalary.salary_date"
                @datevalue="(val)=> driverSalary.salary_date = val"
              />
            </div>
          </div>
          <div class="col-3">
            <tl-select
              label="Month"
              :options="['January', 'February']"
              v-model="driverSalary.month"
              @change="(val) => driverSalary.month=val"
            ></tl-select>
          </div>
          <div class="col-3">
            <txt
              label="Salary Amount "
              type="number"
              name="salary_amount"
              v-model="driverSalary.amount"
            />
          </div>
          <div class="col-12 margin-t-m">
            <div class="upload-heading">Upload salary slip</div>
            <upload name="salary_slip" @change="(val)=>driverSalary.salary_slip=val.data.location" />
          </div>
          <div class="col-12 margin-t-m">
            <btn text="Add Bill" type="secondary" @click="addSalaryDetails()" />
          </div>
        </div>
        <div class="margin-t-l">
          <data-table
            :columns="tableColumns"
            :tableData="salaryDetailsList"
            :showinrow="true"
            :showhistory="false"
            :showedit="false"
            @delete="deleteDriverSalary($event)"
          >
            <template v-slot:rowcontent="slotprops">
              <div>
                <p v-if="slotprops.value.column.key == 'srNo'">{{slotprops.value.index+1}}</p>
                <p
                  v-if="slotprops.value.column.key == 'driver_name'"
                >{{slotprops.value.record[slotprops.value.column.key]}}</p>
                <p
                  v-if="slotprops.value.column.key == 'licence_number'"
                >{{slotprops.value.record[slotprops.value.column.key]}}</p>
                <p
                  v-if="slotprops.value.column.key == 'amount'"
                >{{slotprops.value.record[slotprops.value.column.key]}}</p>
                <p
                  v-if="slotprops.value.column.key == 'proofs'"
                >{{slotprops.value.record[slotprops.value.column.key].length}}</p>
              </div>
            </template>
          </data-table>
        </div>
      </div>
    </div>
    <div class="modal custom-modal" v-if="showModal">
      <div class="modal-content modal-sm">
        <div class="modal-header">
          <div class="row">
            <div class="col-8">
              <h3>Add Driver Details</h3>
            </div>
            <div class="col-4">
              <a href="javascript:void(0)" @click="okbtn" class="close-btn">close</a>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-6">
              <txt
                label="Driver Name"
                name="driver_name"
                placeholder="Driver name"
                v-model="driverDetails.driver_name"
              />
            </div>
            <div class="col-6">
              <txt
                label="Licence Number"
                name="licence_number"
                placeholder="Licence number"
                v-model="driverDetails.licence_number"
              />
            </div>
            <div class="col-12 margin-t-m">
              <div class="upload-heading">Upload Licence</div>
              <upload
                name="licence_url"
                @change="(val)=>driverDetails.licence_url=val.data.location"
              />
            </div>
          </div>
          <div class="row margin-t-l">
            <div class="col-6 align-right">
              <btn text="Cancel" type="secondary" @click="okbtn"></btn>
            </div>
            <div class="col-6">
              <btn text="Save" type="primary" @click="addDriver()"></btn>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pop-up-message
      v-if="showSuccessMsg"
      :message="`Dependent added succesfully.`"
      btnText="Back"
      @back="back"
    ></pop-up-message>
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" @click="back" />
          <btn text="Save" type="primary" @click="submit" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      showSuccessMsg: false,
      showModal: false,
      toast: false,
      errmsg: "",
      name: "",
      vehicle: "",
      relation: "",
      driverDetails: {
        driver_name: "",
        licence_number: "",
        licence_url: ""
      },
      driverSalary: {
        driver: "",
        amount: 0,
        salary_slip: "",
        month: "",
        salary_date: ""
      },
      tableColumns: [
        {
          label: "Sr. No.",
          key: "srNo"
        },
        {
          label: "Driver Name",
          key: "driver_name"
        },
        {
          label: "License Number",
          key: "licence_number"
        },
        {
          label: "Amount",
          key: "amount"
        },
        {
          label: "Proofs",
          key: "proofs"
        }
      ],
      salaryDetailsList: [],
      driverColumns: [
        {
          label: "Sr. No.",
          key: "srNo"
        },
        {
          label: "Driver Name",
          key: "driver_name"
        },
        {
          label: "Licence Number",
          key: "licence_number"
        },
        {
          label: "Proofs",
          key: "proofs"
        }
      ],
      driverDetailsList: []
    };
  },
  computed: {
    ...mapState("dashboard/organisation/utilities/itdeclarations", {
      driverData: state => state.DS
    })
  },
  activated() {
    this.showSuccessMsg = false;
    this.setDriverData();
  },
  methods: {
    ...mapActions({
      saveDSData: "dashboard/organisation/utilities/itdeclarations/saveDS"
    }),
    back() {
      this.$router.go(-1);
    },
    async submit() {
      try {
        await this.saveDSData({
          id: this.$route.query.id,
          driverList: this.driverDetailsList,
          proofs: this.salaryDetailsList.map(item => {
            return item.proofs[0];
          }),
          salaryList: this.salaryDetailsList
        });
        this.showSuccessMsg = true;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    addDriver() {
      try {
        this.driverDetailsList.push({
          driver_name: this.driverDetails.driver_name,
          licence_number: this.driverDetails.licence_number,
          proofs: [this.driverDetails.licence_url]
        });
        this.driverDetails.driver_name = "";
        this.driverDetails.licence_number = "";
        this.driverDetails.licence_url = "";
        this.showModal = false;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    addSalaryDetails() {
      try {
        this.salaryDetailsList.push({
          driver_name: this.driverSalary.driver
            ? this.driverSalary.driver.driver_name
            : this.driverDetailsList[0].driver_name,
          licence_number: this.driverSalary.driver
            ? this.driverSalary.driver.licence_number
            : this.driverDetailsList[0].licence_number,
          amount: this.driverSalary.amount,
          proofs: [this.driverSalary.salary_slip]
        });
        this.resetForm();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    setDriverData() {
      try {
        if (this.driverData[this.$route.query.id]) {
          this.driverDetailsList = this.driverData[
            this.$route.query.id
          ].driverList;
          this.salaryDetailsList = this.driverData[
            this.$route.query.id
          ].salaryList;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    initCreateForm() {
      this.showModal = true;
    },
    okbtn() {
      this.showModal = false;
    },
    resetForm() {
      try {
        this.driverSalary = {
          driver: "",
          amount: 0,
          salary_slip: "",
          month: "",
          salary_date: ""
        };
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    deleteDriver(record) {
      try {
        let index = this.driverDetailsList.findIndex(
          item => item.name == record.name
        );
        this.driverDetailsList.splice(index, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    deleteDriverSalary(record) {
      try {
        let index = this.salaryDetailsList.findIndex(
          item => item.name == record.name
        );
        this.salaryDetailsList.splice(index, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}
.heading_new {
  width: auto;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}
.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.d_heading {
  font-size: 14px;
  font-weight: 600;
  opacity: 0.68;
  color: #646464;
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
  span {
    color: #858585;
    font-size: 18px;
  }
}
.custom-add-button {
  text-align: center;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}
.close-btn {
  float: right;
  margin-top: 15px;
  color: #fff;
  text-decoration: none;
  font-weight: 600;
}
.upload-heading {
  font-size: 13px;
  opacity: 0.78;
  font-weight: 500;
}
.justify-content-flex-end {
  justify-content: flex-end;
}
</style>
